import "../../styles/components/FilterModal.css";

const GeneNamesForm = ({ editedGeneNames, setEditedGeneNames, loading }) => {
  // Handler for updating the gene names based on textarea input
  const handleGeneNamesChange = (e) => {
    setEditedGeneNames(e.target.value);
  };

  return (
    <div style={{ padding: "2px" }}>
      {/* <h2>Gene Names</h2> */}
      <textarea
        className="form-control"
        rows="15"
        value={editedGeneNames}
        onChange={handleGeneNamesChange}
        disabled={loading} // Disable textarea during loading
        style={{ 
          height: "400px",
          fontFamily: "var(--bs-font-sans-serif)",
          fontSize: "var(--bs-body-font-size)",
          lineHeight: "var(--bs-body-line-height)"
        }}
      />
    </div>
  );
};

export default GeneNamesForm;
